<script>
  import { DropdownItem } from '@sveltestrap/sveltestrap';

  export let folder = [];
  export let selectedFolders = [];
  export let onSelectFolder = () => {};
</script>

<DropdownItem header class="level-2 {folder.files.length ? 'group' : ''}">
  <label for={folder.id}>
    <i class:os-icon-folder-minus={folder.files.length} class:os-icon-folder={!folder.files.length} />
    <input
      type="checkbox"
      id={folder.id}
      checked={selectedFolders.includes(folder.unique)}
      on:change={(e) => {
        onSelectFolder(e, folder.unique, !!folder.files.length);
      }}
    />
    <span>{folder.name}</span>
  </label>
</DropdownItem>

{#each folder?.files as subfile}
  {#if subfile.files}
    <DropdownItem header class="level-3 {subfile.files.length ? 'group' : ''}">
      <label for={subfile.id}>
        <i class:os-icon-folder-minus={subfile.files.length} class:os-icon-folder={!subfile.files.length} />
        <input
          type="checkbox"
          id={subfile.id}
          checked={selectedFolders.includes(subfile.unique)}
          on:change={(e) => {
            onSelectFolder(e, subfile.unique, !!subfile.files.length);
          }}
        />
        <span>{subfile.name}</span>
      </label>
    </DropdownItem>

    {#each subfile.files as subsubfile}
      <DropdownItem header class="level-4 {subsubfile.files.length ? 'group' : ''}">
        <label for={subsubfile.id}>
          <i class:os-icon-folder-minus={subsubfile.files.length} class:os-icon-folder={!subsubfile.files.length} />
          <input
            type="checkbox"
            id={subsubfile.id}
            checked={selectedFolders.includes(subsubfile.unique)}
            on:change={(e) => {
              onSelectFolder(e, subsubfile.unique, !!subsubfile.files.length);
            }}
          />
          <span>{subsubfile.name}</span>
        </label>
      </DropdownItem>

      {#each subsubfile.files as subsubsubfile}
        <DropdownItem header class="level-5 {subsubsubfile.files.length ? 'group' : ''}">
          <label for={subsubsubfile.id}>
            <i
              class:os-icon-folder-minus={subsubsubfile.files.length}
              class:os-icon-folder={!subsubsubfile.files.length}
            />
            <input
              type="checkbox"
              id={subsubsubfile.id}
              checked={selectedFolders.includes(subsubsubfile.unique)}
              on:change={(e) => {
                onSelectFolder(e, subsubsubfile.unique, !!subsubsubfile.files.length);
              }}
            />
            <span>{subsubsubfile.name}</span>
          </label>
        </DropdownItem>
      {/each}
    {/each}
  {:else}
    <DropdownItem>
      <label for={subfile.id}>
        <input
          type="checkbox"
          id={subfile.id}
          checked={selectedFolders.includes(subfile.unique)}
          on:change={(e) => {
            onSelectFolder(e, subfile.unique);
          }}
        />
        <span>{subfile.name}</span>
      </label>
    </DropdownItem>
  {/if}
{/each}
